export default "__VITE_ASSET__3ebf29dc__"